import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/profile')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      // Allow guests to view public profiles: /profile/:identifier
      // but block own-profile management routes (/profile/, /profile/edit, /profile/change-password)
      const parts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
      const isPublicProfileView =
        parts.length === 2 &&
        parts[0] === 'profile' &&
        !['edit', 'change-password'].includes(parts[1]);
      if (!isPublicProfileView) {
        throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
      }
    }
  },
  component: () => <Outlet />,
});
